/**
 * Safely extract a human-readable error string from an axios error response.
 * FastAPI returns Pydantic 422 errors as `detail: [{type, loc, msg, input, ctx}]`
 * which crashes React if pushed directly into a JSX child (e.g. via sonner toasts).
 *
 * Usage:
 *   } catch (err) {
 *     toast.error(extractApiError(err, "Signup failed — please try again"));
 *   }
 */
export function extractApiError(err, fallback = "Something went wrong — please try again") {
  const d = err?.response?.data?.detail;
  if (Array.isArray(d)) {
    return d.map((x) => x?.msg || x?.message || JSON.stringify(x)).filter(Boolean).join("; ") || fallback;
  }
  if (typeof d === "string") return d;
  if (d && typeof d === "object" && typeof d.msg === "string") return d.msg;
  if (typeof err?.message === "string" && err.message !== "Network Error") return err.message;
  return fallback;
}
